module.exports = __webpack_public_path__ + "img/JavaScript.97beb694.png";